import { Injectable } from '@angular/core';
import {
  AngularFirestore,
  QueryDocumentSnapshot,
  QuerySnapshot,
} from '@angular/fire/firestore';
import { Collection } from '../interfaces/collection';
import { FirestoreService } from './firestore.service';
import { UserService } from './user.service';
import * as firebase from 'firebase/app';

@Injectable({
  providedIn: 'root',
})
export class CollectionsService {
  collections?: Collection[] = [];
  lastDocSnapshot?: QueryDocumentSnapshot<Collection>;

  constructor(
    public userService: UserService,
    private firestoreService: FirestoreService,
    private firestore: AngularFirestore
  ) {
    if (this.userService.user?.uid) {
      this.getCollections();
    } else {
      // wait for user to change, then get collections
      this.userService.userSubject.subscribe(() => {
        this.getCollections();
      });
    }
  }

  setCollection(collection: Collection): void {
    this.firestoreService
      .setDocument(`collections/${collection.uid}`, collection)
      .then(() => {
        this.collections = [];
        this.getCollections();
      });
  }

  getCollections(): void {
    this.collections = [];
    this.firestore
      .collection('collections', (ref) =>
        ref
          .limit(16)
          .where('members', 'array-contains', this.userService.user?.uid)
          .orderBy('modifiedAt')
      )
      .get()
      .toPromise()
      .then((querySnapshot: QuerySnapshot<Collection>) => {
        // set last doc snapshot for lazy loading
        this.lastDocSnapshot = querySnapshot.docs[querySnapshot.size - 1];
        // iterate over query docs and push to collections array
        querySnapshot.docs.forEach(
          (docSnapshot: QueryDocumentSnapshot<Collection>) => {
            this.collections.push(docSnapshot.data());
          }
        );
      });
  }

  addPage(page: any, collectionId: string): Promise<void> {
    return this.firestoreService.updateDocument(`collections/${collectionId}`, {
      pages: firebase.default.firestore.FieldValue.arrayUnion(page),
    });
  }

  removePage(page: any, collectionId: string): Promise<void> {
    return this.firestoreService.updateDocument(`collections/${collectionId}`, {
      pages: firebase.default.firestore.FieldValue.arrayRemove(page),
    });
  }
}
